import { withStyles, Tooltip } from "@material-ui/core";

export const WhiteArrowTooltip = withStyles(theme => ({
  arrow: {
    color: "#ffffff"
  },
  tooltip: {
    backgroundColor: "#ffffff",
    color: "#32325d",
    boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
    maxWidth: "250px",
    padding: "10px",
    fontSize: "12px"
  },
  popper: {
    top: "-5px !important"
  }
}))(Tooltip);
